import { Box, BoxProps } from '@mui/material';
// components
import { HEADER, NAV } from '@raas/shared/src/shared-config-global';
import { useSettingsContext } from '@raas/shared/src/components/minimals/settings';
// hooks
import useResponsive from '@raas/shared/src/hooks/useResponsive';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }: BoxProps) {
  const { themeLayout } = useSettingsContext();
  const isDesktop = useResponsive('up', 'lg');

  const isNavHorizontal = themeLayout === 'horizontal';
  const isNavMini = themeLayout === 'mini';

  const desktopPadding = {
    px: 2,
    pt: `${HEADER.H_DASHBOARD_DESKTOP + 80}px`,
    pb: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
  };

  const horizontalLayoutStyle = {
    pt: `${HEADER.H_MOBILE + SPACING}px`,
    pb: `${HEADER.H_MOBILE + SPACING}px`,
    ...(isDesktop && desktopPadding),
  };

  const verticalLayoutStyle = {
    flexGrow: 1,
    py: `${HEADER.H_MOBILE + SPACING}px`,
    ...(isDesktop && {
      ...desktopPadding,
      width: `calc(100% - ${isNavMini ? NAV.W_DASHBOARD_MINI : NAV.W_DASHBOARD}px)`,
    }),
  };

  return (
    <Box
      component="main"
      sx={{
        ...(isNavHorizontal ? horizontalLayoutStyle : verticalLayoutStyle),
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
